type OvertimeAndPeriodValue = {
  overtime: string | null;
  period: string | null;
};

export function getSoccerPeriodsValue(value: string | OvertimeAndPeriodValue) {
  if (typeof value === 'string') {
    return value;
  }

  if (value.period && !value.overtime) {
    return value.period;
  }

  return value.overtime;
}
